export default "__VITE_ASSET__BitC$lmD__"